import { render } from "./Create.vue?vue&type=template&id=397e47d0&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=397e47d0&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=397e47d0&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397e47d0"]])

export default __exports__